module.exports = __webpack_public_path__ + "img/latest-bg.06f59748.jpg";